export const myApplicationFactory = (job, status, inviteId) => {
  return {
    ...job,
    inviteId: inviteId,
    jobStatus: status,
  };
};

// Path: src\helper\factory.js
